import { createClient } from '@/prismicio';

/**
 * Simple page fetchers that rely on Prismic's built-in fetch caching.
 * These exist primarily for code organization and potential future optimization.
 * Prismic automatically caches responses with 300s revalidation in production.
 */

export const getHomePage = async () => {
  const client = createClient();
  return await client.getByUID('page', 'home');
};

export const getPageByUID = async (uid: string) => {
  const client = createClient();
  return await client.getByUID('page', uid);
};

export const getBlogByUID = async (uid: string) => {
  const client = createClient();
  return await client.getByUID('blog', uid);
};

export const getBlogHomeLayout = async () => {
  const client = createClient();
  return await client.getSingle('blog_home_layout');
};
